import isDevEnvironment from './isDevEnvironment'
import ReactGA from 'react-ga4'

export function logGoogleEvent(name: string, data = {}): void {
	if (isDevEnvironment()) console.log(`logGoogleEvent: ${name}`)
	ReactGA.event(name, data)
}

export default logGoogleEvent
